import axios from "~src/utils/axios";
import type { IItemString } from "~src/interfaces/commom";
import { API_BADMINTON_URL, API_BASKETBALL_URL, API_ESPORTS_URL, API_FOOTBALL_URL, API_TENNIS_URL, API_VOLLEYBALL_URL } from "~src/utils/constant";

const BASE_URL: IItemString = {
  football: API_FOOTBALL_URL,
  basketball: API_BASKETBALL_URL,
  tennis: API_TENNIS_URL,
  badminton: API_BADMINTON_URL,
  volleyball: API_VOLLEYBALL_URL,
  esports: API_ESPORTS_URL,
};

const getApiUrl = (sportType: string, path: string) => {
  return `${BASE_URL[sportType]}/${path}`;
};

export const getOddsByDate = async (
  sportType: string,
  siteId: number,
  ymd: string
) => {
  const url = getApiUrl(sportType, `${sportType}/odds/${siteId}/${ymd}`);

  return await axios.get(url);
};

export const getOddsLiveChanges = async (sportType: string, siteId: number) => {
  const url = getApiUrl(sportType, `${sportType}/odds-live-changes/${siteId}`);

  return await axios.get(url);
};

export const getOddsMatch = async (sportType: any, matchId: any) => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/odd`);

  return await axios.get(url);
};

export const getOddsByLeague = async (
  sportType: string,
  leagueId: string,
  seasonId: string,
  siteId: number
) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/odds/league/${leagueId}/season/${seasonId}/provider/${siteId}`
  );

  return await axios.get(url);
};
